import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Form,
  Row,
  Col,
} from "reactstrap";
import { HorarioAsistenciaService } from "service/HorarioAsistenciaService";
import FSelect from "components/Select/FSelect";

const DIAS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

const horarioService = new HorarioAsistenciaService();

const ModalHorarioAsistencia = ({ isOpen, toggle, selectedHorario, onSave }) => {
  const [horario, setHorario] = useState({
    dia: 1,
    horaInicioManiana: "",
    horaFinManiana: "",
    horaInicioTarde: "",
    horaFinTarde: "",
    estado: "1",
  });

  useEffect(() => {
    if (isOpen) {
      setHorario(
        selectedHorario ?? {
          dia: 1,
          horaInicioManiana: "",
          horaFinManiana: "",
          horaInicioTarde: "",
          horaFinTarde: "",
          estado: "1",
        }
      );
    }
  }, [isOpen, selectedHorario]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHorario((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!horario.horaInicioManiana || !horario.horaFinManiana) {
      alert("Las horas de mañana son obligatorias");
      return;
    }
    try {
      const dto = { ...horario, dia: Number(horario.dia) };
      const res = dto._id
        ? await horarioService.updateHorario(dto)
        : await horarioService.addHorario(dto);
      if (res?.confirmation === "success") {
        alert(dto._id ? "Horario actualizado" : "Horario registrado");
        onSave();
        toggle();
      } else {
        alert(res?.message || "Error al procesar");
      }
    } catch (error) {
      console.error("Error guardando horario:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" backdrop="static">
      <ModalHeader toggle={toggle}>
        {horario._id ? "Editar Horario de Asistencia" : "Nuevo Horario de Asistencia"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Día</Label>
                <FSelect
                  name="dia"
                  value={horario.dia}
                  onChange={handleChange}
                  options={DIAS.map((d, i) => ({ value: i, label: d }))}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Estado</Label>
                <FSelect
                  name="estado"
                  value={horario.estado}
                  onChange={handleChange}
                  options={[
                    { value: "1", label: "Activo" },
                    { value: "0", label: "Inactivo" },
                  ]}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Hora Inicio Mañana</Label>
                <Input
                  type="time"
                  name="horaInicioManiana"
                  value={horario.horaInicioManiana}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Hora Fin Mañana</Label>
                <Input
                  type="time"
                  name="horaFinManiana"
                  value={horario.horaFinManiana}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Hora Inicio Tarde (opcional)</Label>
                <Input
                  type="time"
                  name="horaInicioTarde"
                  value={horario.horaInicioTarde}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Hora Fin Tarde (opcional)</Label>
                <Input
                  type="time"
                  name="horaFinTarde"
                  value={horario.horaFinTarde}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
        <Button color="primary" onClick={handleSave}>Guardar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalHorarioAsistencia;
